<template>
  <b-modal
    v-model="modalData.status"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    title="Malzeme Ekle"
    size="lg"
    centered
  >
    <material-form :refresh-data-list="refreshDataList" />
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue'
import MaterialForm from '@/views/Services/View/MaterialModal/MaterialForm.vue'

export default {
  name: 'MaterialModal',
  components: {
    BModal,
    MaterialForm,
  },
  props: {
    refreshDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    modalData() {
      return this.$store.getters['serviceMaterials/modalData']
    },
  },
}
</script>
